import { Container, Row, Col } from "react-bootstrap";

const FooterComponent = () => {
  return (
    <div>
    </div>
  );
};

export default FooterComponent;
